module.exports = "<img src=\"{{ campaign.banner }}\" class=\"banner-image d-block\" alt=\"Banner\" />\n"